/** Expenses has a tab per job, `/expenses/<tab>`: every expense, and (for approvers) the ones waiting for a decision. */
export const EXPENSES_PATH = '/expenses';

export const EXPENSE_TABS = ['all', 'approvals'] as const;
export type ExpenseTab = (typeof EXPENSE_TABS)[number];

export const EXPENSE_TAB_LABELS: Record<ExpenseTab, string> = { all: 'All expenses', approvals: 'Approvals' };

export function expenseTabPath(tab: ExpenseTab): string {
  return `${EXPENSES_PATH}/${tab}`;
}
